<template>
  <v-card flat class="card-peso-medio-box mt-2">
    <v-row align="center" class="ma-0 pa-2 flex-nowrap">
      <v-icon small class="icon-peso-medio">fas fa-chart-bar</v-icon>
      <v-col class="pa-0 pl-2">
        <v-row class="ma-0" align="center">
          <span class="label-peso-medio">Peso médio diário</span>
          <v-tooltip top max-width="260">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                x-small
                class="icon-info-peso-medio ml-1"
                v-bind="attrs"
                v-on="on"
              >
                fas fa-info-circle
              </v-icon>
            </template>
            <span>
              Peso médio diário (projetado): Corresponde ao peso médio dos
              lotes incluídos na programação para este dia, considerando o
              peso informado para cada lote.
            </span>
          </v-tooltip>
        </v-row>
        <span class="label-peso-medio-subtitulo">(projetado)</span>
      </v-col>
      <v-spacer />
      <span class="value-peso-medio">{{ pesoMedioFormatado }} kg</span>
    </v-row>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CardTotalPesoMedioDiario",
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
    itemPlanta: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState("programacaoAbate", ["listBatchsAllocated"]),
    lotesDoDia() {
      if (!this.listBatchsAllocated) return [];
      return this.listBatchsAllocated.filter(
        (item) =>
          item.cdPlantaAbate === this.itemPlanta.cdPlantaAbate &&
          item.stDiaAlocado === this.itemData.value &&
          !item.blDeleted
      );
    },
    pesoMedioDiario() {
      const lotes = this.lotesDoDia;
      if (!lotes.length) return 0;

      const total = lotes.reduce(
        (acc, item) => acc + (parseFloat(item.nrPesoDia) || 0),
        0
      );
      return total / lotes.length;
    },
    pesoMedioFormatado() {
      return (this.pesoMedioDiario || 0).toFixed(1).replace(".", ",");
    },
  },
};
</script>
